export default {"src":"/_next/static/media/BMY.eebe56ef.svg","height":18,"width":18};